export const getRacingEventData = (racingData, eventType) =>
  racingData?.selections?.find(item => item.name.replace(/\s/g, '').toLowerCase() === eventType.replace(/\s/g, '').toLowerCase())